var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSaEnkeltLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 121.73,
    height: 40.823,
    viewBox: "0 0 121.73 40.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(-2.079 -18.43)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1043",
    transform: "translate(2.079 28.238)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M8.619,53.945c4.512,0,6.8-3.051,6.8-9.089,0-4.8-1.33-7.214-5.514-9.873L8.249,33.871A4.771,4.771,0,0,1,5.677,29.36c0-2.289,1.33-3.814,3.313-3.814,2.092,0,3.117,1.242,3.117,3.814v.262a1.345,1.345,0,0,0,1.221,1.46h.153a1.3,1.3,0,0,0,1.373-1.242v-.5c0-4.185-2.071-6.408-5.95-6.408-3.64,0-6.081,2.572-6.081,6.386,0,3.226,1.155,5.231,4.119,7.149l1.678,1.112c2.942,1.918,3.945,3.792,3.945,7.476,0,4.185-1.242,6.234-3.814,6.234-2.31,0-3.814-1.853-3.814-4.73a8.333,8.333,0,0,1,.545-2.9,1.82,1.82,0,0,0,0-1.395,1.045,1.045,0,0,0-.632-.545,1.629,1.629,0,0,0-2.049.959,10.68,10.68,0,0,0-.719,4.054c0,4.446,2.528,7.193,6.582,7.193h0Z",
    transform: "translate(-2.079 -22.93)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1044",
    transform: "translate(35.755 28.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M27.076,48.94H22.412V39.154h4.01a2.387,2.387,0,1,0,.109-4.773H22.412V27.733h4.664a2.387,2.387,0,1,0,.109-4.773H20.93c-2.223,0-3.4,1.133-3.4,3.269V50.466c0,2.136,1.177,3.269,3.4,3.269h6.146a2.387,2.387,0,1,0,.109-4.773h-.109Z",
    transform: "translate(-17.53 -22.96)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1045",
    transform: "translate(50.401 27.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M38.112,30.422c0-5.013-2.4-7.672-6.931-7.672s-6.931,2.637-6.931,7.672V51.476a2.476,2.476,0,0,0,4.948,0V30.509c0-2.092.632-3.051,1.962-3.051s1.962.981,1.962,3.051V51.476a2.476,2.476,0,0,0,4.948.2V30.4h0Z",
    transform: "translate(-24.25 -22.75)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1046",
    transform: "translate(68.012 28.039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M45.974,41.586c0-2.289-.61-3.705-1.962-4.468l-.24-.131.218-.174a4.5,4.5,0,0,0,1.635-3.945V25.413a2.476,2.476,0,0,0-4.948-.2v6.757c0,1.831-.676,2.659-2.18,2.659H37.278v-9.2a2.476,2.476,0,0,0-4.948-.2v26.2a2.476,2.476,0,0,0,4.948,0V39.145h1.395c1.439,0,2.354,1.177,2.354,3.008v9.285a2.476,2.476,0,0,0,4.948,0V41.629h0Z",
    transform: "translate(-32.33 -22.839)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1047",
    transform: "translate(85.296 28.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M49.806,48.94H45.142V39.154h4.01a2.387,2.387,0,0,0,0-4.773h-4.01V27.733h4.664a2.387,2.387,0,0,0,.109-4.773H43.66c-2.223,0-3.4,1.133-3.4,3.269V50.466c0,2.136,1.177,3.269,3.4,3.269h6.146a2.387,2.387,0,1,0,.109-4.773h-.109Z",
    transform: "translate(-40.26 -22.96)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1048",
    transform: "translate(100.095 28.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M55.616,49.094H52V25.4a2.476,2.476,0,1,0-4.948-.2V50.62c0,2.136,1.177,3.269,3.4,3.269h5.187a2.387,2.387,0,0,0,0-4.773h0Z",
    transform: "translate(-47.05 -22.829)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1049",
    transform: "translate(109.968 28.303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M63,22.96h-8.98a2.387,2.387,0,0,0-.109,4.773h2.114V51.251a2.476,2.476,0,1,0,4.948.2V27.733h2.005a2.387,2.387,0,0,0,.109-4.773h-.109Z",
    transform: "translate(-51.58 -22.96)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1050",
    transform: "translate(18.602 27.693)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M22.65,29.807c0-4.533-2.376-7.127-6.5-7.127s-6.5,2.594-6.5,7.127V52.78a1.46,1.46,0,0,0,2.921,0V42.8h7.171V52.78a1.46,1.46,0,0,0,2.921,0V29.807h0ZM19.73,40.138H12.559V30.374c0-3.357,1.177-4.969,3.574-4.969s3.574,1.635,3.574,4.969v9.743h0Z",
    transform: "translate(-9.66 -22.68)",
    fill: "#368181"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1051",
    transform: "translate(21.762 18.43)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M14.467,25.1h-.044a3.349,3.349,0,1,1,2.376-.981,3.247,3.247,0,0,1-2.332.981Zm-.022-4.381A1.046,1.046,0,0,0,13.4,21.765a1.033,1.033,0,0,0,1.046,1.046.92.92,0,0,0,.719-.305,1.033,1.033,0,0,0-.741-1.765Z",
    transform: "translate(-11.11 -18.43)",
    fill: "#368181"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaEnkeltLogo);
export default __webpack_public_path__ + "static/media/sa-enkelt-logo.62e512154740c26add25d95e90873cc8.svg";
export { ForwardRef as ReactComponent };